<template>
  <div class="vue-sidebar">
    <div class="sidebar-wrap">
      <div class="sidebar-content" v-if="pathname === '' || pathname === '#'">
        <button id="close-sidebar" @click="closeSidebar()">X</button>
        <LoginSidebar v-if="mode === 'login'" @close="closeSidebar()" />
        <!-- <RegisterSidebar v-if="mode === 'register'" @register="showModal" /> -->
        <ForgotSidebar v-if="mode === 'forgot'" @close="closeSidebar()" />
        <!-- <a class="logo_dnie" @click="dniAccess()"><img src="@/assets/img/logo_dnie.jpg" alt="logo icasal"></a> -->
        <a v-if="mode === 'login'" @click="mode = 'forgot'">Olvidé mi contraseña</a>
        <a v-if="mode === 'forgot'" @click="mode = 'login'">Ya tengo cuenta</a>
        <!-- <a v-if="mode === 'login'" @click="mode = 'register'" @close="closeSidebar()">Nuevo usuario</a> -->
      </div>
      <div class="sidebar-content" v-if="pathname === '#confirmReset'">
        <button id="close-sidebar" @click="closeSidebar()">X</button>
        <ConfirmSidebar @close="closeSidebar()" />
      </div>
      <!-- <div class="logo-icasal">
        <img src="@/assets/img/logo_icasal.png" alt="logo icasal">
      </div> -->
    </div>
    <SharedNotification />
  </div>
</template>

<script>
// Services
import LoginSidebar from '@/components/LoginSidebar.vue';
// import RegisterSidebar from '@/components/RegisterSidebar.vue';
import ForgotSidebar from '@/components/ForgotSidebar.vue';
import ConfirmSidebar from '@/components/ConfirmSidebar.vue';
import SharedNotification from '@/shared/SharedNotification.vue'

import JQuery from 'jquery';
const $ = JQuery;

export default {
  name: 'vue-sidebar',
  el: '#vue-sidebar',
  data() {
    return {
      notif: {},
      mode: 'login',
      openModal: false,
      pathname: window.location.hash,
      credentialsModal: {}
    }
  },
  created() {
    const checkUrl = this.pathname.split("?");
    this.pathname = checkUrl[0];
  },
  methods: {
    closeSidebar() {
      document.querySelector('#auth_sidebar').style.display = 'none';
      this.mode = 'login';
    },
    showNotification(event) {
      this.notif = event
    },
    showModal(event) {
      this.openModal = true;
      this.credentialsModal = event;
    },
    dniAccess() {
      $.ajax({
          type: "GET",
          url: 'https://dniicasaldev.undanet.com/dniaccess',
          async:true,
          dataType : 'jsonp', //you may use jsonp for cross origin request
          crossDomain:true,
          success: function(data) {
            window.open('https://icasalweb.undanet.com/#/login?token=' + data.token + '&user=aflores&pass=undanet2015', '_blank')
          }
      });
    }
  },
  components: {
    LoginSidebar,
    // RegisterSidebar,
    ForgotSidebar,
    ConfirmSidebar,
    SharedNotification
  }
}
</script>